/**
 * plansApi.ts (portail client) - grille tarifaire centralisee.
 * Anonyme. Editee dans l'admin, exposee via GET /api/plans. Consommee par
 * BillingPage (et le site marketing). Fallback gracieux cote UI si API down.
 */
import { apiFetch } from './apiClient';

export type PlanLang = 'fr' | 'nl' | 'de' | 'en';

export interface PlanText {
  name:             string;
  target:           string;
  price:            string;
  yearlyCommitment: string;
  cta:              string;
  features:         string[];
}

export interface PlanConfig {
  key:        string;            // free | starter | pro | business | enterprise
  order:      number;
  monthlyEur: number | null;
  featured:   boolean;
  free:       boolean;
  /** v2026.06 - Reduction % via partenaire integrateur (affichee en rouge). null/0 = aucune. */
  partnerDiscountPct?: number | null;
  t:          Record<PlanLang, PlanText>;
}

export const plansApi = {
  list: () => apiFetch<{ plans: PlanConfig[]; updatedAt: string | null }>('/plans'),
};
